import type { ApiService } from "@phurshell/psiapp-frontend-core/domain";

/**
 * Atualização de conta do paciente com a MESMA requisição do legado (PUT users/:id, JSON).
 * O `userRepo.updateUser` do core usa `POST users/:id/edit` em multipart, que muda o endpoint
 * e grava booleanos "true" como 0 (ver ENTREGAS F02/F14b). Revisar ao alinhar com o core.
 */
export class PatientAccountDataSource {
  constructor(private readonly api: ApiService) {}

  update(id: number, params: Record<string, unknown>) {
    return this.api.put(`users/${id}`, params);
  }
}
